import React from "react";
const Spacer = ({ section, className }) => {
  return section?.is_hidden ? <div /> : <div id={section?.spacerId} className={section?.size === "s" ? `pb-12 lg:pb-22 ${className}` : section?.size === "m" ? `pb-30 lg:pb-34 ${className}` : `pb-34 lg:pb-40 ${className}`} />;
};
export default Spacer;
